import {safeClone, ViewStream} from 'spyne';
import {PageTraits} from 'traits/page-traits';
import {BlogTraits} from 'traits/blog-traits';

import { PageDeckSlidePresentation } from 'components/pages/page-deck-slide-presentation';
import PageTmplInvestors from './templates/page-investors.tmpl.html';
import {PageDocsItem} from 'components/pages/page-docs-item';

export class PageDeck extends ViewStream {
  constructor(props = {}) {
    props.traits = PageTraits;
    props.data = safeClone(props.appData.investorsPageContent[0]);
    props.isBlog = true;
    props.class = 'app-page-docs';
    props.id = 'l1-deck';

    //console.log('investors is ',props);
    //console.log('quick start page data ',props.appData);
    props.data.contentLen = PageTraits.page$GetContentLength(props.data);
    //props.template = require("./templates/page-docs.tmpl.html");
    props.template = PageTmplInvestors;
    //props.template = require("./templates/page-quick-start.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [['CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT', 'disposeViewStream']];
  }

  broadcastEvents() {
    return [
      ['a[data-channel=\'ROUTE\']', 'click'],
    ];
  }

  addPageDocItems() {
    const addPageItems = (data) => {

      //console.log("DATA INVESTORS IS ", data);
      this.appendView(new PageDocsItem({data}), '.page-content');
    };

    this.props.appData.investorsPageContent.forEach(addPageItems);
  }

  onRendered() {

    // this.blog$CheckToAddBlogItems();
    this.addChannel('CHANNEL_APP_ROUTE', true);
    this.page$InitPage();
    this.page$checkFor404();

    this.appendView(new PageDeckSlidePresentation({

      data: this.props.data.presentation

    }))

   //console.log("THE SLIDE IS ",this.props.data)

   // this.addPageDocItems();

    //this.addIframe();
    //this.appendView(new CodeGeneratorHolder(),  "#code-container");
    //this.appendView(new CodeContainerDetails(), "#code-container");
    //this.appendView(new CodePlaygroundView());
  }
}
